/**
 * Use slug in public URLs only when it is a safe path segment.
 * Dots conflict with static assets (e.g. `/pt-br/logo.png`), so fallback to id.
 */
export function getPublicStorePathSegment(id: string, slug?: string | null): string {
  const s = slug?.trim();
  if (!s) return id;
  if (s.includes('/') || s.includes('.') || s.includes('?') || s.includes('#')) return id;
  return s;
}
